import { captionStrong } from '../../styles/commonStyles';
import RupTooltip from '../rupTooltip';
import Stack from '@mui/material/Stack';
import { createStyles, makeStyles } from '@mui/styles';
import { Colors, Icons } from 'copyright-clearance-center-common-ui';

const useStyles = makeStyles(() =>
	createStyles({
		headerTitle: {
			display: 'flex',
			gap: '0.25rem',
			alignItems: 'center',
			flex: '1 0 0',
			height: '1.5rem'
		}
	})
);

export interface IControlContainerProps {
	header: string;
	toolTip?: string;
	action?: React.ReactElement;
	children?: React.ReactNode;
	testId?: string;
	width?: string;
	height?: string;
}

const ControlContainer: React.FunctionComponent<IControlContainerProps> = ({
	header,
	toolTip,
	action,
	children,
	testId,
	width,
	height
}) => {
	const classes = useStyles();
	return (
		<Stack
			border={`1px solid ${Colors.neutral200}`}
			data-test-id={testId || 'control-container'}
			width={width}
			height={height}
		>
			<Stack
				direction="row"
				justifyContent="space-between"
				alignItems="center"
				sx={{
					...captionStrong,
					color: Colors.neutral900,
					background: Colors.neutral50,
					padding: '0.375rem 0.75rem'
				}}
			>
				<div className={classes.headerTitle}>
					{header}
					{toolTip && (
						<RupTooltip
							sx={{ maxWidth: '15rem' }}
							title={<span dangerouslySetInnerHTML={{ __html: toolTip }} />}
						>
							<span
								style={{ color: Colors.primary500 }}
								className="rup-icon rup-icon--sm"
								dangerouslySetInnerHTML={{ __html: Icons.InfoIcon }}
							/>
						</RupTooltip>
					)}
				</div>
				{action}
			</Stack>
			{children}
		</Stack>
	);
};

export default ControlContainer;
